import router from './router';
import store from './store';

import { setDocumentTitle, domTitle } from '@/utils/domUtil';

const whiteList = ['Root', 'Index', 'WxLogin', 'ContractCheck', 'other', '404']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  to.meta &&
    typeof to.meta.title !== 'undefined' &&
    setDocumentTitle(`${domTitle}`);
  if (store.getters.login) {
    next();
    /* has token */
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next();
    } else {
      if (store)
        try {
          if (store.getters.getToken) {
            await store.dispatch('user/getUserInfoAction');
            next({ path: to.fullPath });
          } else {
            store.commit('user/SET_LOGINFLAG', true);
            next({ path: '/index' });
          }
        } catch {
          store.commit('user/SET_LOGINFLAG', true);
          next({ path: '/index' });
        }
    }
  }
});
